function getIdSelector(id) {
  return `#${id}`
}

export const ELEMENT_ID = {
  FORM_SECTION: 'form'
}

export const ELEMENT_SELECTOR_BY_ELEMENT_ID = Object.entries(ELEMENT_ID).reduce(
  (acc, [, value]) => ({
    ...acc,
    [value]: getIdSelector(value)
  }),
  {}
)
